import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hello, I'm Bhasit Shah.`}</h1>
    <p>{`I'm an undergrate senior majoring in Computer Science and Statistics at Rutgers University in New Brunswick seeking entry-level software engineering positions.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      